class SubNavElement extends HTMLElement {
  #trs = [];

  connectedCallback() {
    addEventListener("click", this);
  }

  disconnectedCallback() {
    removeEventListener("click", this);
  }

  handleEvent(e) {
    if (e.type === "click") {
      if (e.composedPath().includes(this)) {
        const button = e.target.closest("a, button");

        if (button) {
          if (button.classList.contains("subnav-toggle")) {
            this.toggle();
          } else {
            const list = button.closest("ul");
            const buttons = list.querySelectorAll("a, button");
            for (const otherButton of buttons) {
              otherButton.classList.toggle("active", otherButton === button);
            }

            const label = this.querySelector(".subnav-label");
            label.textContent = button.textContent.trim();

            this.toggle(false);

            const id = button.dataset.id;
            if (id) {
              this.dispatchEvent(
                new CustomEvent("subnav-select", { detail: { id }, bubbles: true })
              );
            }
          }
          return;
        }
      }

      if (this.hasAttribute("open")) {
        this.toggle(false);
      }
    }
  }

  async toggle(force) {
    const prev = this.hasAttribute("open");
    const span = this.querySelector(".subnav-label-wrapper");
    const items = [...this.querySelectorAll("li")];

    const spanWidth = span.scrollWidth;

    const open = this.toggleAttribute("open", force);
    if (open === prev) return;

    for (const tr of this.#trs) {
      tr.cancel();
    }
    this.#trs = [];

    const direction = open ? "normal" : "reverse";

    const tr = span.animate(
      { width: [spanWidth+"px", 0] },
      { direction, duration: 300, easing: "ease" },
    );
    this.#trs.push(tr);

    const n = items.length;
    for (let i = 0; i < n; i++) {
      const j = n - i - 1;
      const t = (i + 1) * 8;
      const duration = 150 + i * 50;
      const tr = items[j].animate(
        {
          transform: [`translateY(${t}px)`, "translateY(0)"],
          opacity: [0, 1],
          filter: ["blur(8px)", "blur(0)"],
        },
        { direction, duration, easing: "ease" },
      );
      this.#trs.push(tr);
    }

    try {
      await Promise.all(this.#trs.map(tr => tr.finished));
      this.#trs = [];
    } catch {}
  }
}

customElements.define("sub-nav", SubNavElement);
